export const CommercialTypeData = [
  { label: 'Commande', value: 0 },
  { label: 'Prospection', value: 1 },
  { label: 'Compétition', value: 2 },
  { label: 'Autres...', value: 3 }
]
